import React from 'react';
import PropTypes from 'prop-types';
import './SignPreview.css';
import SafeIframe from '../SafeIframe/SafeIframe';

// Use "globalThis" instead of "window", "self", or "global" (javascript:S7764)
const window = globalThis.window;

/**
 * Component to preview a sign in an iframe.
 * @param {Object} props - The component props.
 * @param {Object} props.sign - The sign object containing id and other details.
 * @param {number} props.sign.id - The unique identifier for the sign.
 * @param {string} props.sign.name - The name of the sign.
 * @param {string} [props.sign.description] - An optional description of the sign.
 * @param {number} [props.sign.width] - The width of the sign for display purposes.
 * @param {number} [props.sign.height] - The height of the sign for display purposes.
 * @returns {JSX.Element} The sign preview UI.
 */
export default function SignPreview({ sign }) {
  const aspectRatio = `${sign.width} / ${sign.height}`;
  const relativeUrl = `/player/?sign=${sign.id}&nocontrol=1`;
  const absoluteUrl = `${window.location.origin}${relativeUrl}`;

  const copyLinkHandler = () => {
    const url = absoluteUrl;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        alert('Link copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy link: ', err);
        alert('Failed to copy link. Please try again.');
      });
  };

  return (
    <div className="signpage-preview">
      <h2>
        <span>
          {'Preview '}
          <button
            type="button"
            className="material-icons"
            onClick={copyLinkHandler}
            title="copy preview link"
          >
            link
          </button>
        </span>
        <span>
          <a
            href={absoluteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="material-icons"
            title="open preview in new tab"
          >
            open_in_new
          </a>
        </span>
      </h2>
      <SafeIframe
        dataTest="preview-sign"
        style={{ aspectRatio }}
        src={relativeUrl}
        title="Preview Page"
      />
    </div>
  );
}

SignPreview.propTypes = {
  sign: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
};
